export const baseUrl = "https://driverservicebackend.codeinnepal.com.np/api";
// export const baseUrl = "http://localhost:8000/api";
